<p-autoComplete [(ngModel)]="programPlace" (ngModelChange)="programPlaceChange.emit($event)"
  name="programPlace" [disabled]="mode !== DetailMode.EDITION"
  class="program-place-autocomplete acted-highlight-req metadata-field" [required]="required"
  [ngClass]="(mode === 'edition' && recommended && isEmpty()) ? 'acted-highlight-recommended' : ''"
  [suggestions]="allPlaces" (completeMethod)="getPlaceSuggestions($event)"
  [multiple]="false" [forceSelection]="true" optionLabel="name"
  [dropdown]="false" dropdownMode="current" i18n-placeholder="@@common-none" placeholder="(none)" appendTo="body"
  [tabindex]="tabindex">
  <!-- define custom template for filter options -->
  <ng-template pTemplate="item" let-place>
    ({{place.admin_zone_2.adm2_name}}): {{place.name}}
    @if (place.code) {
      (Acted)
    }
  </ng-template>
</p-autoComplete>
<!-- Put back [minQueryLength]="3" once this bug is fixed: https://github.com/primefaces/primeng/issues/19218           -->

@if (mode === 'edition' && recommended && isEmpty()) {
  <app-required-field-text/>
}
